import React from "react";
import BillingHistoryContainer from "../../containers/ProfileContainer/BillingHistoryContainer";

const BillingHistoryPage = () => {
  return <BillingHistoryContainer />;
};

export default BillingHistoryPage;
